import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { PAGE_TYPES } from '@/constants';

const editHistory = {
  computed: {
    ...mapGetters(['currentPage', 'currentSite', 'history']),
  },
  mixins: [guid],
  methods: {
    setEditHistory(params) {
      if (this.pageEditDiff()) {
        let snapshot;
        if (PAGE_TYPES.includes(this.currentPage.type)) {
          snapshot = this.currentPage.blocks;
        } else {
          snapshot = this.currentPage;
        }
        this.$store.dispatch('addToHistory', {
          _id: this.guid(),
          type: params.type,
          meta: params.meta,
          snapshot,
          counts: {
            pageForms: this.currentPage.forms,
            pageDraftForms: this.currentPage.draftForms,
            siteForms: this.currentSite.forms,
          },
        });
      }
    },
    pageEditDiff() {
      const pop = this.history[0];
      let previousSnapshot;
      let lastTouch;
      if (PAGE_TYPES.includes(this.currentPage.type)) {
        previousSnapshot = { blocks: pop.snapshot };
        lastTouch = { blocks: this.currentPage.blocks };
      } else {
        previousSnapshot = pop.snapshot;
        lastTouch = this.currentPage;
      }
      return !_.isEqual(previousSnapshot, lastTouch);
    },
  },
};

export { editHistory };



// WEBPACK FOOTER //
// ./src/mixins/history.js